import { Model } from '../../shared-features/models/model';
import { Expose } from 'class-transformer';
import { InvoiceTransportation } from './invoice-transportation';

export class InvoiceTransportationDetails extends Model {
  @Expose()
  count: number;

  @Expose()
  invoiceTransportationPayment: InvoiceTransportation[];

  @Expose()
  paidCount: number;

  @Expose()
  pendingCount: number;

  @Expose()
  rejectedCount: number;

  @Expose()
  totalCount: number;
}
